import { Link } from "react-router-dom";
import type { RankItem } from "@/types/content";
import { formatHeat } from "@/utils/format";

interface RankListProps {
  items: RankItem[];
}

function rankStyle(rank: number): string {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-accent-500 text-accent-950";
  if (rank === 3) return "bg-secondary-500 text-background-50";
  return "bg-background-200 text-foreground-600";
}

function TrendTag({ trend, change }: { trend: RankItem["trend"]; change: string }) {
  if (trend === "up") {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-medium text-primary-600">
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-arrow-up-line text-[12px]"></i>
        </span>
        {change}
      </span>
    );
  }
  if (trend === "down") {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-medium text-secondary-600">
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-arrow-down-line text-[12px]"></i>
        </span>
        {change}
      </span>
    );
  }
  return <span className="text-xs font-medium text-foreground-400">{change}</span>;
}

export default function RankList({ items }: RankListProps) {
  return (
    <ol className="flex flex-col gap-2">
      {items.map((item) => (
        <li key={item.slug}>
          <Link
            to={`/article/${item.slug}`}
            className="group flex items-center gap-3 rounded-xl border border-transparent px-3 py-3 transition-colors duration-200 hover:border-primary-200 hover:bg-primary-50/60 md:gap-4"
          >
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${rankStyle(
                item.rank,
              )}`}
            >
              {item.rank}
            </span>
            <span className="flex min-w-0 flex-1 flex-col gap-1">
              <span className="truncate text-sm font-medium text-foreground-900 transition-colors duration-200 group-hover:text-primary-700">
                {item.title}
              </span>
              <span className="flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-full bg-background-200/80 px-2 py-0.5">
                  {item.category}
                </span>
                <span className="flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-fire-line text-[12px] text-primary-400"></i>
                  </span>
                  {formatHeat(item.heat)}
                </span>
              </span>
            </span>
            <span className="hidden shrink-0 sm:block">
              <TrendTag trend={item.trend} change={item.change} />
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}